import { render, staticRenderFns } from "./ChatInputArea.vue?vue&type=template&id=38d21d11&scoped=true"
import script from "./ChatInputArea.vue?vue&type=script&lang=ts"
export * from "./ChatInputArea.vue?vue&type=script&lang=ts"
import style0 from "./ChatInputArea.vue?vue&type=style&index=0&id=38d21d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d21d11",
  null
  
)

export default component.exports